import Sidebar from "./modules/sidebar";
document.addEventListener("DOMContentLoaded", function () {
    const sidebarMenu = new Sidebar(
        '.header-menu__btn',
        '.sidebar-menu__overlay',
        '.sidebar-menu',
        '.sidebar-list__link-trigger'
    );
    sidebarMenu.init();
    $(".team-carousel").owlCarousel({
      nav: true,
      dots: true,
      navText: ["<svg width=\"16\" height=\"10\" viewBox=\"0 0 16 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
      "<path d=\"M15.0909 4.10714L3.09091 4.10714L5.72727 1.51786C6.09091 1.16071 6.09091 0.625 5.72727 0.267857C5.36364 -0.0892857 4.81818 -0.0892857 4.45455 0.267857L0.272727 4.375C-0.0909091 4.73214 -0.0909091 5.26786 0.272727 5.625L4.45455 9.73214C4.81818 10.0893 5.36364 10.0893 5.72727 9.73214C6.09091 9.375 6.09091 8.83929 5.72727 8.48214L3.09091 5.89286L15.0909 5.89286C15.5455 5.89286 16 5.53571 16 5C16 4.46429 15.5455 4.10714 15.0909 4.10714Z\" fill=\"#B00000\"/>\n" +
      "</svg>\n","<svg width=\"18\" height=\"11\" viewBox=\"0 0 18 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
      "<path d=\"M1.90909 5.89286L13.9091 5.89286L11.2727 8.48214C10.9091 8.83929 10.9091 9.375 11.2727 9.73214C11.6364 10.0893 12.1818 10.0893 12.5455 9.73214L16.7273 5.625C17.0909 5.26786 17.0909 4.73214 16.7273 4.375L12.5455 0.267857C12.1818 -0.0892853 11.6364 -0.0892854 11.2727 0.267857C10.9091 0.624999 10.9091 1.16071 11.2727 1.51786L13.9091 4.10714L1.90909 4.10714C1.45455 4.10714 1 4.46428 1 5C1 5.53571 1.45455 5.89286 1.90909 5.89286Z\" fill=\"#B00000\"/>\n" +
      "</svg>\n"],
      responsive : {
         // breakpoint from 0 up
         0 : {
            items: 1,
            nav: true,
            dots: true,
            // autoWidth: true,
         },
         // breakpoint from 768 up
         767 : {
            items: 2,
            nav: true,
            margin:24,
         },
         // breakpoint from 1200 up
         1199 : {
            items: 2,
            margin:24,
         }
      }
   });
    const sliderInit = () => {
        if ($(window).width() > 768){
            $(".team-carousel").trigger('destroy.owl.carousel');
        }
    }

    $(window).resize(function(){
        sliderInit();
    });

    sliderInit();

   $('[data-fancybox-thanks]').fancybox({
      touch : false,
   });

    $(document).ready(function($) {
        $(document).on( "click", 'a[href^="#"]', function( e ) {
            e.preventDefault();
            let target = this.hash,
                $target = $(target),
                headerOffset;
            if (window.innerWidth <= 1199 && $target[0].id === 'form') {
                headerOffset = 75;
            } else if ($target[0].id === 'form') {
                headerOffset = 145;
            } else if (window.innerWidth > 1200) {
                headerOffset = 100;
            } else if (window.innerWidth <= 1199) {
                headerOffset = 50;
            } else if (window.innerWidth <= 991) {
                headerOffset = 20;
            } else if (window.innerWidth <= 575) {
                headerOffset = 20;
            }
            $('html, body').stop().animate({ scrollTop: $target.offset().top - headerOffset}, 300);
        });
    });

    let header = $(".header");
    const headerBlock = () => {
        let scroll = $(window).scrollTop();

        if (scroll >= 40) {
            header.addClass("scrolled");
        } else {
            header.removeClass("scrolled");
        }
    }
    headerBlock();

    $(window).scroll(function() {
        headerBlock();
    });
});
